import { useEffect, useState } from 'react';

/** Q-panelens färger i Qvestiums ljusa tema (gammelrosa accent, se T i App.tsx och index.css). */
export const QT = {
  surface: '#ffffff',
  surface2: '#f7f5f6',
  border: '#e8e6e7',
  text: '#111111',
  textSub: '#4a4a4a',
  textMuted: '#8f8a8c',
  accent: 'hsl(var(--primary))',
  accentDim: 'hsl(var(--primary) / 0.15)',
  accentFill: '#111111',
  onAccent: '#ffffff',
  success: '#2e7d32',
  danger: 'hsl(var(--destructive))',
  mic: 'hsl(var(--primary))',
  micOn: '#d63b5b',
};

export const Q_FONT = 'inherit';

/** Samma brytpunkt som App.tsx (MOBILE_BREAKPOINT). */
const MOBILE_MAX = 760;

export function useIsMobile(): boolean {
  const get = () => (typeof window !== 'undefined' ? window.innerWidth < MOBILE_MAX : false);
  const [mobile, setMobile] = useState(get);
  useEffect(() => {
    const on = () => setMobile(get());
    window.addEventListener('resize', on);
    return () => window.removeEventListener('resize', on);
  }, []);
  return mobile;
}
